var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCategoryShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.636,
    height: 30,
    viewBox: "0 0 63.636 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Category",
    transform: "translate(-319.646 -201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    transform: "translate(319.646 201)",
    fill: "none",
    stroke: "#243746",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.636,
    height: 30,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62.636,
    height: 29,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7881",
    "data-name": "Group 7881",
    transform: "translate(-0.717)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Share",
    transform: "translate(342 220)",
    fill: "#243746",
    fontSize: 12,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Share"))), /*#__PURE__*/React.createElement("path", {
    id: "np_share_1233951_000000",
    d: "M21.034,9.99v1.252h2.911a.485.485,0,0,1,.485.485v5.822a.485.485,0,0,1-.485.485H17.153a.485.485,0,0,1-.485-.485V11.728a.485.485,0,0,1,.485-.485h2.911V9.989l-.548.548a.485.485,0,0,1-.686-.686l1.379-1.379a.479.479,0,0,1,.338-.141l0,0a.476.476,0,0,1,.338.139l1.378,1.379a.485.485,0,0,1-.686.686Zm-.971,2.223v-.971h-1.94a.485.485,0,0,1,0,.971Zm.971,0H23.46v-.971H21.034Zm-.971,0H17.638v4.851H23.46V12.213H21.034v2.427a.485.485,0,0,1-.971,0Zm3.4,0h-.485a.485.485,0,0,1,0-.971h.485Z",
    transform: "translate(312.97 202.387)",
    fill: "#243746"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCategoryShare);
export default __webpack_public_path__ + "static/media/Edit_Category_Share.c76b47f8.svg";
export { ForwardRef as ReactComponent };